/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bright_Tough_Mantis_FoldInputs */

const fr_bright_tough_mantis_fold = /** @type {(inputs: Bright_Tough_Mantis_FoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prog`)
};

/**

* @param {Bright_Tough_Mantis_FoldInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const bright_tough_mantis_fold = /** @type {((inputs?: Bright_Tough_Mantis_FoldInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bright_Tough_Mantis_FoldInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_bright_tough_mantis_fold(inputs)
});